module.exports = __webpack_public_path__ + "static/media/premium-packs-icon.f78be2d3.svg";